var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperlikereporticon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2290"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 187",
    cx: 20.75,
    cy: 20,
    r: 20,
    fill: "#CEE4E7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hotel_class"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_398_2092",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 8.75,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_398_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hotel_class_2",
    d: "M24.8538 23.3075L28.4903 20.1825L30.7114 20.3749L26.6383 23.9018L27.8422 29.1825L25.9557 28.0364L24.8538 23.3075ZM22.7249 16.7095L21.7134 14.3364L22.5653 12.2788L24.5095 16.8768L22.7249 16.7095ZM16.1 25.8249L19.25 23.9249L22.4 25.8499L21.575 22.2499L24.35 19.8499L20.7 19.5249L19.25 16.1249L17.8 19.4999L14.15 19.8249L16.925 22.2499L16.1 25.8249ZM13.825 28.9613L15.2577 22.7922L10.4712 18.6441L16.7865 18.0961L19.25 12.2788L21.7134 18.0961L28.0287 18.6441L23.2422 22.7922L24.6749 28.9613L19.25 25.6883L13.825 28.9613Z",
    fill: "#1C1B1F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperlikereporticon);
export default __webpack_public_path__ + "static/media/superlikereporticon.7bcfef602f79494ec79bf5e6400132f5.svg";
export { ForwardRef as ReactComponent };